import PropTypes from 'prop-types'
import { Dialog, Link, Text, Image, Center } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util'
import SearchFormPng from '@images/search_form.png'

export const SearchGuidePopupModal = ({ handleClose, isOpen = true }) => (
  <Dialog.Root placement="center" size="md" open={isOpen} onOpenChange={(details) => !details.open && handleClose()}>
    <Dialog.Backdrop />
    <Dialog.Positioner>
      <Dialog.Content fontSize="sm">
        <Dialog.Body mt={6}>
          <Text>他ジャンルの検索は各ジャンルTOP、全ジャンル検索はHOMEにある検索ボックスからご利用いただけます。</Text>
          <Center>
            <Image src={buildAssetUrlString(SearchFormPng)} alt="検索について" />
          </Center>
        </Dialog.Body>
        <Dialog.Footer justifyContent="center" fontSize="sm">
          <Link onClick={handleClose}>閉じる</Link>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Positioner>
  </Dialog.Root>
)

SearchGuidePopupModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
}
